let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2oID3")).then(() => parcelRequire('frYvE'));